import Swiper from 'swiper';
export default {
  init() {
    // JavaScript to be fired on the people page
    (function () {
      // People Swiper
      var mySwiper = undefined;

      function initSwiper() {
        var screenWidth = $(window).width();
        if (screenWidth < 480 && mySwiper == undefined) {
          $('.people-slider .swiper-container').each(function () {
            var $this = $(this);
            mySwiper = new Swiper($this, {
              loop: true,
              slidesPerView: 1,
              navigation: {
                nextEl: $this.parents('.people-slider').find('.slider-button-next')[0],
                prevEl: $this.parents('.people-slider').find('.slider-button-prev')[0],
              },
              pagination: {
                el: $this.parents('.people-slider').find('.swiper-pagination-box')[0],
                type: 'fraction',
              },
            });
          });
        } else if (screenWidth > 481 && mySwiper != undefined) {
          $('.people-slider .swiper-container').each(function () {
            var $this = $(this);
            $this[0].swiper.destroy();
          });
          mySwiper = undefined;
          $('.people-slider .swiper-wrapper').removeAttr('style');
          $('.people-slider .swiper-slide').removeAttr('style');
        }
      }

      initSwiper();
      window.addEventListener('resize', initSwiper);

      // Tab Swiper
      var tabSwiper = undefined;

      function initTabSwiper() {
        if (tabSwiper == undefined) {
          $('.tab-slider .swiper-container').each(function () {

            var $this = $(this);
            tabSwiper = new Swiper($this, {
              navigation: {
                nextEl: $this.parents('.tab-slider').find('.slider-button-next')[0],
                prevEl: $this.parents('.tab-slider').find('.slider-button-prev')[0],
              },
              pagination: {
                el: $this.parents('.tab-slider').find('.swiper-pagination-box')[0],
                type: 'fraction',
              },
              breakpoints: {
                480: {
                  slidesPerView: 1,
                  slidesPerGroup: 1
                },
                700: {
                  slidesPerView: 2,
                  slidesPerGroup: 2
                },
                1024: {
                  slidesPerView: 2,
                  slidesPerGroup: 2
                },
              },
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 30,
              observer: true,
              observeParents: true,
              simulateTouch: false,
              loopFillGroupWithBlank: true,
              loop: true,
            });
          });
        }
      }

      initTabSwiper();
      window.addEventListener('resize', initTabSwiper);

      // Tabs
      $('.js-tabs > li > a').click(function () {
        var hrefElem = $(this).attr('href');
        var text = $(this).html();

        $('.js-tabs-mobile').find('label').html(text);
        $('.js-tabs-mobile').find('input[type="checkbox"]').attr('checked', false);

        if (hrefElem.length) {
          $('.js-tabs > li').removeClass('current');
          $(this).closest('li').addClass('current');

          $('.tab-container').hide();
          $(hrefElem + '.tab-container').show();
        }

        return false;
      });

      // Sticky Sidebar
      if($('.sticky-start').length) {
        var $sticky = $('.sticky-start');
        var $stickyrStopper = $('.sticky-stopper');
        if ($sticky.offset()) {
          var generalSidebarHeight = $sticky.innerHeight();
          var stickyTop = $sticky.offset().top;
          var stickOffset = 180;
          var stickyStopperPosition = $stickyrStopper.offset().top;
          var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
          var diff = stopPoint - stickOffset;

          $(window).scroll(function () { // scroll event
            var windowTop = $(window).scrollTop(); // returns number

            if (stopPoint < windowTop) {
              $sticky.css({position: 'absolute', top: diff});
            } else if (stickyTop < windowTop + stickOffset) {
              $sticky.css({position: 'fixed', top: stickOffset});
            } else {
              $sticky.css({position: 'absolute', top: 'initial'});
            }
          });
        }
      }

      // Jump To
      $('.js-jump-to > li > a').click(function () {
        var section = $(this).attr('href');
        $('html, body').animate({scrollTop: $(section).offset().top - 65}, 500);
        return false;
      });

      var mainNavLinks = document.querySelectorAll('.js-jump-to a');
      var mainSections = document.querySelectorAll('.people-section .people-box');

      var lastId;
      var cur = [];

      window.addEventListener("scroll", event => {
        var fromTop = window.scrollY;

        mainNavLinks.forEach(link => {
          var section = document.querySelector(link.hash);

          if (
            section.offsetTop <= fromTop &&
            section.offsetTop + section.offsetHeight > fromTop
          ) {
            link.classList.add("current");
          } else {
            link.classList.remove("current");
          }
        });
      });
    })();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/people.js